import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1d02cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "AddContractLabor",
  class: "ms-2 mt-2 txtLeft",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { id: "spnMessage" })
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { id: "contractlaborrequest-form" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div id=\"contract-labor-heading\" class=\"row\" data-v-a1d02cb8><div class=\"form-group col-2\" data-v-a1d02cb8><label data-v-a1d02cb8>DATE</label></div><div class=\"form-group col-2\" data-v-a1d02cb8><label class=\"text-uppercase\" data-v-a1d02cb8>shift</label></div><div class=\"form-group col-2\" data-v-a1d02cb8><label class=\"text-uppercase\" data-v-a1d02cb8>skill</label></div><div class=\"form-group col-2\" data-v-a1d02cb8><label class=\"text-uppercase\" data-v-a1d02cb8>skill &amp; Specialization</label></div><div class=\"form-group col-3\" data-v-a1d02cb8><label data-v-a1d02cb8>NOTE(OPTIONAL)</label></div></div>", 1)
const _hoisted_7 = {
  key: 0,
  id: "view"
}
const _hoisted_8 = { class: "form-group col-2" }
const _hoisted_9 = { class: "form-group col-2" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "requiredControl material-icons",
  "aria-hidden": "true"
}
const _hoisted_13 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_14 = {
  key: 2,
  class: "shift-validation-error-messages validation-error requiredTxt"
}
const _hoisted_15 = { class: "form-group col-2" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "requiredControl material-icons",
  "aria-hidden": "true"
}
const _hoisted_19 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_20 = { class: "form-group col-2" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "requiredControl material-icons",
  "aria-hidden": "true"
}
const _hoisted_24 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_25 = {
  key: 2,
  id: "divSkillsErrorMessage",
  class: "font-small text-start",
  style: {"display":"block"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " No specialization available for this department. ", -1))
const _hoisted_27 = { class: "form-group col-3" }
const _hoisted_28 = { class: "form-group col-1 pl-0" }
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = { class: "row actionable-new-create-controls-container" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "lineStyle" }, null, -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "row mb-4" }
const _hoisted_37 = {
  key: 0,
  id: "noContentMsg",
  class: "col-md-9 contract-text display"
}
const _hoisted_38 = { class: "col" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "vertical-center" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = {
  class: "col-md-3 fa-xl",
  style: {"text-align":"right"}
}
const _hoisted_43 = {
  class: "col-md-9",
  style: {"text-align":"left"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automation has been enabled for this Department. Manual submissions are not allowed at this time.", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 0,
  id: "contract-labor-grid-content-loading",
  style: {"text-align":"center","display":"none"}
}
const _hoisted_48 = { class: "fa-2x" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_50 = { class: "row mb-4" }
const _hoisted_51 = {
  key: 0,
  id: "noContentMsg",
  class: "col-md-9 contract-text display"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "newIcon" }, "There are no pending contract labor requests for your department at this time.", -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "col" }
const _hoisted_55 = ["href"]
const _hoisted_56 = {
  key: 0,
  id: "gridContent",
  class: "display"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 mb-2 contract-header" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "newIcon" }, "Pending Requests")
  ])
], -1))
const _hoisted_58 = { class: "row gridSpace" }
const _hoisted_59 = {
  class: "active col-md-12 grid-table",
  id: "pendingReqGrid"
}
const _hoisted_60 = {
  key: 1,
  id: "contract-labor-content-loading",
  class: "loadingDiv1",
  style: {"padding":"5px"}
}
const _hoisted_61 = { style: {"text-align":"center"} }
const _hoisted_62 = { class: "fa-2x" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Processing...")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_paginator = _resolveComponent("neu-paginator")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_table_row_count = _resolveComponent("neu-table-row-count")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_container = _resolveComponent("neu-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", _hoisted_5, [
          _hoisted_6,
          (_ctx.contractRequestControls != null && _ctx.contractRequestControls.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractRequestControls, (dataItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row",
                    key: dataItem.Id
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_Datepicker, {
                        modelValue: dataItem.RequestDate,
                        "onUpdate:modelValue": ($event: any) => ((dataItem.RequestDate) = $event),
                        inputClassName: "dp-custom-input",
                        weekStart: "0",
                        class: "form-control requestDate",
                        enableTimePicker: false,
                        autoApply: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["neu-select departmentShifts", [dataItem.IsShiftRequired || dataItem.IsShowShiftValidationErrorMsg ? 'hasError': '']]),
                        "data-role": "dropdownlist",
                        "onUpdate:modelValue": ($event: any) => ((dataItem.SelectedShift) = $event)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departmentShiftsList, (shift) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: shift.deptShiftId,
                            key: shift.deptShiftId
                          }, _toDisplayString(shift.deptShiftDescription), 9, _hoisted_11))
                        }), 128))
                      ], 10, _hoisted_10), [
                        [_vModelSelect, dataItem.SelectedShift]
                      ]),
                      _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                        default: _withCtx(() => [
                          _createTextVNode("arrow_drop_down")
                        ]),
                        _: 1
                      }),
                      (dataItem.IsShiftRequired || dataItem.IsShowShiftValidationErrorMsg)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "error"))
                        : _createCommentVNode("", true),
                      (dataItem.IsShiftRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Required"))
                        : _createCommentVNode("", true),
                      (dataItem.IsShowShiftValidationErrorMsg)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(dataItem.ShiftValidationErrorMsg), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["neu-select fsskills", [dataItem.IsSkillRequired ? 'hasError': '']]),
                        "data-role": "dropdownlist",
                        "onUpdate:modelValue": ($event: any) => ((dataItem.SelectedSkill) = $event)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: skill.skillLevelId,
                            key: skill.skillLevelId
                          }, _toDisplayString(skill.description), 9, _hoisted_17))
                        }), 128))
                      ], 10, _hoisted_16), [
                        [_vModelSelect, dataItem.SelectedSkill]
                      ]),
                      _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                        default: _withCtx(() => [
                          _createTextVNode("arrow_drop_down")
                        ]),
                        _: 1
                      }),
                      (dataItem.IsSkillRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "error"))
                        : _createCommentVNode("", true),
                      (dataItem.IsSkillRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Required"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["neu-select fsskills", [dataItem.IsSkillSpecializationRequired ? 'hasError': '']]),
                        "data-role": "dropdownlist",
                        "onUpdate:modelValue": ($event: any) => ((dataItem.SelectedSkillSpecialization) = $event)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillSpecializations, (skillSpec) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: skillSpec.wfFoldergroupID,
                            key: skillSpec.wfFoldergroupID
                          }, _toDisplayString(skillSpec.wfFolderGroupName), 9, _hoisted_22))
                        }), 128))
                      ], 10, _hoisted_21), [
                        [_vModelSelect, dataItem.SelectedSkillSpecialization]
                      ]),
                      _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                        default: _withCtx(() => [
                          _createTextVNode("arrow_drop_down")
                        ]),
                        _: 1
                      }),
                      (dataItem.IsSkillSpecializationRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "error"))
                        : _createCommentVNode("", true),
                      (dataItem.IsSkillSpecializationRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Required"))
                        : _createCommentVNode("", true),
                      (dataItem.IsSkillSpecializationExists)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'circle-exclamation'],
                              size: "sm",
                              class: "mr-1"
                            }),
                            _hoisted_26
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_neu_input, {
                        name: "note",
                        modelValue: dataItem.note,
                        "onUpdate:modelValue": ($event: any) => ((dataItem.note) = $event),
                        placeholder: "Request specific contractor by name here..."
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link copy-request-btn p-0",
                        disabled: dataItem.IsDisableCopyBtn,
                        onClick: ($event: any) => (_ctx.copyContractLaborRequestControls(dataItem.Id))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['far', 'copy'],
                          size: "sm",
                          class: "mr-2"
                        }),
                        _createTextVNode(" Copy ")
                      ], 8, _hoisted_29),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link remove-request-btn p-0",
                        disabled: dataItem.IsDisableRemoveBtn,
                        onClick: ($event: any) => (_ctx.removeContractLaborRequestControls(dataItem.Id))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['far', 'trash-alt'],
                          size: "sm",
                          class: "mr-2"
                        }),
                        _createTextVNode(" Remove ")
                      ], 8, _hoisted_30)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", {
          id: "btnAddNew",
          class: "btn btn-link iconStyle",
          disabled: _ctx.isDisableAddButton,
          style: {"text-decoration":"none"},
          href: "#",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAddNewRequest && _ctx.onAddNewRequest(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'plus'],
            size: "sm",
            class: "mr-2"
          }),
          _createTextVNode("NEW ")
        ], 8, _hoisted_33),
        _createVNode(_component_neu_button, {
          type: "button",
          fill: "raised",
          id: "createrequest",
          class: "float-end me-1",
          disabled: _ctx.isDisableCreateRequest,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisableCreateRequest ? null : _ctx.onCreateContractLaborRequests()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" REQUEST ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _hoisted_34,
    (_ctx.isContractLaborNeedAutomationEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            (_ctx.isShowNoContentMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("a", {
                id: "manage-contract-labor-lnk",
                class: "float-end me-1",
                href: _ctx.contractLaborLink,
                target: "_blank"
              }, "Manage Contract Labor", 8, _hoisted_39)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'warning'],
                  size: "2xl",
                  style: {"color":"red"}
                })
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _hoisted_45,
                _createElementVNode("span", null, [
                  _createTextVNode("Use the WF Automation Status Tool by "),
                  _createElementVNode("span", {
                    class: "clickSpan",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showWorkforceRequestStatusPopup && _ctx.showWorkforceRequestStatusPopup(...args)))
                  }, "Clicking here"),
                  _createTextVNode(" to see Automation activity for this department.")
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", null, [
            (_ctx.isShowContractLaborGridLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_font_awesome_icon, {
                      spin: true,
                      icon: ['fas', 'circle-notch'],
                      size: "lg"
                    })
                  ]),
                  _hoisted_49
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            (_ctx.isShowNoContentMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("a", {
                id: "manage-contract-labor-lnk",
                class: "float-end me-1",
                href: _ctx.contractLaborLink,
                target: "_blank"
              }, "Manage Contract Labor", 8, _hoisted_55)
            ])
          ]),
          (_ctx.isShowContractLaborGrid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    (_ctx.dsContractReqGrid != null && _ctx.dsContractReqGrid.length > 0)
                      ? (_openBlock(), _createBlock(_component_neu_card, {
                          key: 0,
                          color: "plain-0",
                          class: "p-0 m-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_table, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_table_row, {
                                  columns: _ctx.columnHeaders,
                                  size: "small",
                                  header: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                      return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                        key: column,
                                        icon: _ctx.columnIcons[column],
                                        slot: column,
                                        style: {"padding-top":"25px !important"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(column), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["icon", "slot"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["columns"]),
                                _createVNode(_component_neu_table_body, { align: "left" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dsContractReqGridList, (dataItem) => {
                                      return (_openBlock(), _createBlock(_component_neu_table_row, {
                                        columns: _ctx.columnHeaders,
                                        slot: _ctx.column,
                                        key: dataItem,
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_neu_label, { slot: "Date" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.Date), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_neu_label, {
                                            slot: "Shift",
                                            title: dataItem.Shift
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.Shift), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "FS Skill",
                                            title: dataItem.FsSkillLevelDescription
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.FsSkillLevelDescription), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "WF Specialization",
                                            title: dataItem.WfSkill
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.WfSkill), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Requested",
                                            title: dataItem.Requested
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.Requested), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Status",
                                            title: dataItem.Status
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.Status), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Name",
                                            title: dataItem.ResourceName
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.ResourceName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Notes",
                                            title: dataItem.Notes
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(dataItem.Notes), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, { slot: "Actions" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_neu_button, {
                                                type: "button",
                                                fill: "raised",
                                                onClick: ($event: any) => (_ctx.cancelContractLaborRequests(dataItem))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" CANCEL ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["columns", "slot"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.dsContractReqGrid != null && _ctx.dsContractReqGrid.length > 0)
                      ? (_openBlock(), _createBlock(_component_neu_container, {
                          key: 1,
                          fluid: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_neu_col, {
                                  md: "6",
                                  cols: "12",
                                  class: "neu-text-center neu-text-md-left"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_neu_paginator, {
                                      class: "justify-content-start",
                                      onVNeuChange: _cache[3] || (_cache[3] = (ev) => this.pageNum = ev.detail.pageNumber),
                                      total: _ctx.dsContractReqGrid != null && _ctx.dsContractReqGrid.length,
                                      rowsPerPage: _ctx.rowsPerPage
                                    }, null, 8, ["total", "rowsPerPage"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_neu_col, {
                                  md: "6",
                                  cols: "12",
                                  class: "neu-text-center neu-text-md-right"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_neu_table_row_count, {
                                      class: "mt-3",
                                      section: "number",
                                      total: _ctx.dsContractReqGrid != null && _ctx.dsContractReqGrid.length,
                                      "page-number": _ctx.pageNum,
                                      onVNeuChange: _ctx.rowCountChange
                                    }, null, 8, ["total", "page-number", "onVNeuChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowContractLaborContentLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createVNode(_component_font_awesome_icon, {
                      spin: true,
                      icon: ['fas', 'circle-notch'],
                      size: "lg"
                    })
                  ]),
                  _hoisted_63
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}